import { render, staticRenderFns } from "./AvailabilitySchemeEdit.vue?vue&type=template&id=064b7dfa&scoped=true&"
import script from "./AvailabilitySchemeEdit.vue?vue&type=script&lang=js&"
export * from "./AvailabilitySchemeEdit.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilitySchemeEdit.vue?vue&type=style&index=0&id=064b7dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b7dfa",
  null
  
)

export default component.exports